import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const trackingId = process.env.REACT_APP_GA_TRACKING_ID;
if (trackingId) {
    ReactGA.initialize(trackingId, { debug: false });
}

const root = document.getElementById('root');
if (root) {
    ReactDOM.render(<App />, root);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
